import type { ReactNode } from "react";

import { type FlagName, useFlag } from "@/lib/flags";

interface FeatureFlagProps {
  name: FlagName;
  children: ReactNode;
  /** Lo que se muestra con el flag apagado. Por defecto, nada. */
  fallback?: ReactNode;
}

export function FeatureFlag({ name, children, fallback = null }: FeatureFlagProps) {
  return <>{useFlag(name) ? children : fallback}</>;
}
